<template>
  <div class="home">
    <Header />

    <div class="carousel relative">
      <div class="carousel-inner relative overflow-hidden w-full">
        <input
          class="carousel-open"
          type="radio"
          id="carousel-1"
          name="carousel"
          aria-hidden="true"
          hidden
          checked
        />
        <div class="carousel-item absolute" style="height: 25rem">
          <div
            class="h-full w-full mx-auto flex pt-6 md:pt-0 items-center bg-cover bg-center justify-center"
            style="background-image: url('zwartwit.jpg')"
          >
            <div class="container p-8 flex justify-items-end flex-col">
              <p
                class="text-main-300 font-bold md:text-5xl mr-2 text-right text-3xl my-4 break-words w-auto"
              >
                <span class="text-white">Heleen Helleman</span>
              </p>
              <p
                class="text-white font-bold md:text-2xl mr-2 text-right text-2xl my-4 break-words w-auto"
              >
                Advocaat in strafrecht en jeugd(straf)recht
              </p>
              <a
                href="tel:0031620657193"
                class="rounded-lg px-5 md:px-8 py-3 md:py-4 bg-white hover:bg-gray-200 text-gray-800 font-semibold leading-tight shadow-md ml-auto mb-4"
              >
                Bel nu! <span class="text-sm">06 20657193</span>
              </a>
              <iframe
                class="ml-auto"
                frameborder="0"
                allowtransparency="true"
                title="Klantenvertellen Widget"
                src="https://www.klantenvertellen.nl/retrieve-widget.html?button=true&lang=nl&tenantId=99&locationId=1067059"
                width="150"
                height="195"
              >
              </iframe>
            </div>
          </div>
        </div>
      </div>
    </div>

    <section class="bg-white py-3 px-8 md:px-32">
      <div
        class="container mx-auto flex flex-row items-center flex-wrap pt-4 pb-6"
      >
        <div class="py-1 text-xl text-left w-full" style="top:0">
          <p class="mb-5">
            Heeft u te maken met politie, justitie of jeugdhulpverlening en
            vragen over uw rechten of aanpak van uw situatie? Neem dan direct
            contact met mij op, ik ben 24/7 bereikbaar op
            <a href="tel:0031620657193" class="hover:underline font-bold"
              >06 20 65 71 93</a
            >. <br /><br />
            Mijn naam is <b>Heleen Helleman</b>. Ik heb 30 jaar ervaring als
            advocaat in het strafrecht, het jeugd(straf)recht en het burgerlijk
            procesrecht. <br /><br />
            Mijn stijl is persoonlijk, deskundig met duidelijke communicatie,
            betrokkenheid en een doelgerichte strategie, waarbij uw belangen
            altijd voorop staan.
            <br /><br />
            U kunt contact met mij opnemen via telefoon, WhatsApp of e-mail.
            Tijdens het eerste gesprek bespreken wij zowel de inhoud van uw zaak
            als de financiële aspecten en stellen wij gezamenlijk een plan van
            aanpak op.
            <br /><br />
            Mijn uurtarief bedraagt € 200,- exclusief btw. Ook met gefinancierde
            rechtsbijstand (toevoeging) bent u van harte welkom. Voor meer
            informatie over gefinancierde rechtsbijstand verwijs ik u naar de
            website van de Raad voor Rechtsbijstand:
            <a
              href="https://www.rvr.org"
              target="_blank"
              class="hover:underline font-bold"
              >www.rvr.org</a
            >. <br /><br />
            Ik beschik niet over een stichting derdengelden.
          </p>
        </div>
      </div>
    </section>

    <section
      class="bg-gray-100 py-1 bg-cover bg-center px-8 md:px-32"
      style="background-image: url('lawful.jpg')"
    >
      <div
        class="container my-6 mx-auto flex flex-row items-center flex-wrap pt-4 pb-6 opacity-100"
        style="background: rgba(0, 0, 0, 0.45); color: white;"
      >
        <div
          class="px-6 py-1 text-left w-full flex-grow"
          style="min-height: 100%"
        >
          <h2 class="font-bold text-2xl my-3">Contact</h2>
          <p class="text-base mb-5">
            Bereikbaar iedere werkdag tussen 9:00 - 18:00.
          </p>
          <b>Telefoon</b>
          <p class="mb-5">
            <a href="tel:0031620657193" class="hover:underline"
              >+31 6 20657193</a
            >
          </p>
          <b>E-mail</b>
          <p class="mb-5">
            <a
              href="mailto:heleen@advocatenkantoorhelleman.nl"
              class="hover:underline"
              >heleen@advocatenkantoorhelleman.nl</a
            >
          </p>
        </div>
      </div>
    </section>

    <section id="over" class="bg-white py-3 px-8 md:px-32">
      <div
        class="container mx-auto flex flex-row items-center flex-wrap pt-4 pb-12"
      >
        <div class="py-1 text-xl text-left w-full">
          <h2 class="font-bold text-2xl my-3">Over</h2>
          <p class="mb-5">
            Mijn naam is Heleen Helleman en ben sinds 1996 advocaat en
            gespecialiseerd in het strafrecht en het Jeugd(straf/civiel)recht.
            <br /><br />
            Mijn stijl is laagdrempelig, open, eerlijk, betrokken, direct en
            vind het heel belangrijk goed bereikbaar te zijn voor vragen of
            overleg.
            <br /><br />
            Ik heb rechten gestudeerd aan de VU in Amsterdam en heb daarna de
            post academische specialisatie opleiding De Jeugdrecht Advocaat
            gevolgd.
            <br /><br />
            Ik ben 13 jaar werkzaam geweest in Amsterdam bij advocatenkantoor
            Rozendaal en in 2009 ben ik voor mijzelf begonnen.
          </p>
        </div>
      </div>
    </section>

    <footer
      class="bg-gray-800 text-cognac-light text-center p-6 text-xs text-white"
    >
      © {{ new Date().getFullYear() }} Helleman Advocaten | Realisatie:
      <a href="https://egidius.nl" target="_blank" class="hover:underline"
        >Egidius IT</a
      >
    </footer>
  </div>
</template>

<script>
import Header from "../components/Header";

export default {
  name: "Home",
  components: {
    Header
  }
};
</script>
